// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file form/v1/form.proto (package leficaneur.form.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file form/v1/form.proto.
 */
export const file_form_v1_form: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message leficaneur.form.v1.SendRequest
 */
export type SendRequest = Message<"leficaneur.form.v1.SendRequest"> & {
  /**
   * @generated from field: string buyer_type = 1;
   */
  buyerType: string;

  /**
   * @generated from field: repeated leficaneur.form.v1.Person persons = 2;
   */
  persons: Person[];

  /**
   * @generated from field: repeated leficaneur.form.v1.Corporation corporations = 3;
   */
  corporations: Corporation[];

  /**
   * @generated from field: leficaneur.form.v1.Funding funding = 4;
   */
  funding?: Funding | undefined;

  /**
   * @generated from field: leficaneur.form.v1.Notary notary = 5;
   */
  notary?: Notary | undefined;

  /**
   * @generated from field: bool terms_and_conditions = 6;
   */
  termsAndConditions: boolean;

  /**
   * @generated from field: string section1_json = 8;
   */
  section1Json: string;

  /**
   * @generated from field: string dynamic_json = 9;
   */
  dynamicJson: string;

  /**
   * @generated from field: string share_token = 10;
   */
  shareToken: string;

  /**
   * Set when the buyer submits the finished form. A broker saving from the
   * admin side leaves it false, so the submission keeps the status it already
   * has instead of being marked completed.
   *
   * @generated from field: bool completed = 11;
   */
  completed: boolean;

  /**
   * Session token of the broker saving from the admin side. The buyer sends
   * none: their share token is their only credential, so the server keeps the
   * broker's property summary as stored and checks the required answers when
   * they complete the form.
   *
   * @generated from field: string token = 12;
   */
  token: string;
};

/**
 * Describes the message leficaneur.form.v1.SendRequest.
 * Use `create(SendRequestSchema)` to create a new message.
 */
export const SendRequestSchema: GenMessage<SendRequest> = /*@__PURE__*/
  messageDesc(file_form_v1_form, 0);

/**
 * @generated from message leficaneur.form.v1.SendResponse
 */
export type SendResponse = Message<"leficaneur.form.v1.SendResponse"> & {
  /**
   * @generated from field: int32 status = 1;
   */
  status: number;
};

/**
 * Describes the message leficaneur.form.v1.SendResponse.
 * Use `create(SendResponseSchema)` to create a new message.
 */
export const SendResponseSchema: GenMessage<SendResponse> = /*@__PURE__*/
  messageDesc(file_form_v1_form, 1);

/**
 * @generated from message leficaneur.form.v1.CreateFormRequest
 */
export type CreateFormRequest = Message<"leficaneur.form.v1.CreateFormRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string developer = 3;
   */
  developer: string;

  /**
   * @generated from field: string broker = 4;
   */
  broker: string;

  /**
   * @generated from field: string accommodation_type = 5;
   */
  accommodationType: string;

  /**
   * @generated from field: string rooms = 6;
   */
  rooms: string;

  /**
   * @generated from field: string residence_type = 7;
   */
  residenceType: string;

  /**
   * @generated from field: string lot_number = 8;
   */
  lotNumber: string;

  /**
   * @generated from field: string area = 9;
   */
  area: string;

  /**
   * @generated from field: string parking = 10;
   */
  parking: string;

  /**
   * @generated from field: string usage = 11;
   */
  usage: string;

  /**
   * @generated from field: string vat = 12;
   */
  vat: string;

  /**
   * @generated from field: string price = 13;
   */
  price: string;

  /**
   * @generated from field: string buyer_first_name = 14;
   */
  buyerFirstName: string;

  /**
   * @generated from field: string buyer_last_name = 15;
   */
  buyerLastName: string;

  /**
   * @generated from field: string city = 16;
   */
  city: string;

  /**
   * @generated from field: string managed_residence_type = 17;
   */
  managedResidenceType: string;

  /**
   * @generated from field: string buyer_email = 18;
   */
  buyerEmail: string;

  /**
   * @generated from field: string buyer_phone = 19;
   */
  buyerPhone: string;

  /**
   * @generated from field: string buyers_json = 20;
   */
  buyersJson: string;
};

/**
 * Describes the message leficaneur.form.v1.CreateFormRequest.
 * Use `create(CreateFormRequestSchema)` to create a new message.
 */
export const CreateFormRequestSchema: GenMessage<CreateFormRequest> = /*@__PURE__*/
  messageDesc(file_form_v1_form, 2);

/**
 * @generated from message leficaneur.form.v1.CreateFormResponse
 */
export type CreateFormResponse = Message<"leficaneur.form.v1.CreateFormResponse"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * Token of the link the buyers follow to fill in the form. Returned so the
   * admin can copy the link when the invitation could not be emailed.
   *
   * @generated from field: string share_token = 2;
   */
  shareToken: string;

  /**
   * Buyer addresses the invitation was sent to.
   *
   * @generated from field: repeated string emailed_to = 3;
   */
  emailedTo: string[];

  /**
   * Buyer addresses the invitation could not be sent to, either because no SMTP
   * server is configured or because it rejected the message. The form is
   * created either way, so the admin can still share the link by hand.
   *
   * @generated from field: repeated string email_failures = 4;
   */
  emailFailures: string[];
};

/**
 * Describes the message leficaneur.form.v1.CreateFormResponse.
 * Use `create(CreateFormResponseSchema)` to create a new message.
 */
export const CreateFormResponseSchema: GenMessage<CreateFormResponse> = /*@__PURE__*/
  messageDesc(file_form_v1_form, 3);

/**
 * @generated from message leficaneur.form.v1.UpdateSection1Request
 */
export type UpdateSection1Request = Message<"leficaneur.form.v1.UpdateSection1Request"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: string share_token = 2;
   */
  shareToken: string;

  /**
   * @generated from field: string section1_json = 3;
   */
  section1Json: string;
};

/**
 * Describes the message leficaneur.form.v1.UpdateSection1Request.
 * Use `create(UpdateSection1RequestSchema)` to create a new message.
 */
export const UpdateSection1RequestSchema: GenMessage<UpdateSection1Request> = /*@__PURE__*/
  messageDesc(file_form_v1_form, 4);

/**
 * @generated from message leficaneur.form.v1.UpdateSection1Response
 */
export type UpdateSection1Response = Message<"leficaneur.form.v1.UpdateSection1Response"> & {
};

/**
 * Describes the message leficaneur.form.v1.UpdateSection1Response.
 * Use `create(UpdateSection1ResponseSchema)` to create a new message.
 */
export const UpdateSection1ResponseSchema: GenMessage<UpdateSection1Response> = /*@__PURE__*/
  messageDesc(file_form_v1_form, 5);

/**
 * @generated from message leficaneur.form.v1.GetFormDefinitionRequest
 */
export type GetFormDefinitionRequest = Message<"leficaneur.form.v1.GetFormDefinitionRequest"> & {
  /**
   * @generated from field: string share_token = 1;
   */
  shareToken: string;
};

/**
 * Describes the message leficaneur.form.v1.GetFormDefinitionRequest.
 * Use `create(GetFormDefinitionRequestSchema)` to create a new message.
 */
export const GetFormDefinitionRequestSchema: GenMessage<GetFormDefinitionRequest> = /*@__PURE__*/
  messageDesc(file_form_v1_form, 6);

/**
 * @generated from message leficaneur.form.v1.GetFormDefinitionResponse
 */
export type GetFormDefinitionResponse = Message<"leficaneur.form.v1.GetFormDefinitionResponse"> & {
  /**
   * @generated from field: int64 form_id = 1;
   */
  formId: bigint;

  /**
   * @generated from field: string form_name = 2;
   */
  formName: string;

  /**
   * @generated from field: int32 version = 3;
   */
  version: number;

  /**
   * @generated from field: string schema_json = 4;
   */
  schemaJson: string;

  /**
   * @generated from field: string prefill_json = 5;
   */
  prefillJson: string;

  /**
   * @generated from field: string city = 6;
   */
  city: string;

  /**
   * @generated from field: int32 status = 7;
   */
  status: number;

  /**
   * @generated from field: string submitted_at = 8;
   */
  submittedAt: string;

  /**
   * @generated from field: string buyer_first_name = 9;
   */
  buyerFirstName: string;

  /**
   * @generated from field: string buyer_last_name = 10;
   */
  buyerLastName: string;

  /**
   * @generated from field: string buyer_email = 11;
   */
  buyerEmail: string;

  /**
   * @generated from field: string buyer_phone = 12;
   */
  buyerPhone: string;
};

/**
 * Describes the message leficaneur.form.v1.GetFormDefinitionResponse.
 * Use `create(GetFormDefinitionResponseSchema)` to create a new message.
 */
export const GetFormDefinitionResponseSchema: GenMessage<GetFormDefinitionResponse> = /*@__PURE__*/
  messageDesc(file_form_v1_form, 7);

/**
 * @generated from message leficaneur.form.v1.Person
 */
export type Person = Message<"leficaneur.form.v1.Person"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string gender = 2;
   */
  gender: string;

  /**
   * @generated from field: string last_name = 3;
   */
  lastName: string;

  /**
   * @generated from field: string first_name = 4;
   */
  firstName: string;

  /**
   * @generated from field: string phone = 5;
   */
  phone: string;

  /**
   * @generated from field: string email = 6;
   */
  email: string;

  /**
   * @generated from field: string birth_date = 7;
   */
  birthDate: string;

  /**
   * @generated from field: string birth_city = 8;
   */
  birthCity: string;

  /**
   * @generated from field: string birth_country = 9;
   */
  birthCountry: string;

  /**
   * @generated from field: string nationality = 10;
   */
  nationality: string;

  /**
   * @generated from field: string profession = 11;
   */
  profession: string;

  /**
   * @generated from field: string address = 12;
   */
  address: string;

  /**
   * @generated from field: string married = 13;
   */
  married: string;

  /**
   * @generated from field: string children = 14;
   */
  children: string;

  /**
   * @generated from field: string marriage_city = 15;
   */
  marriageCity: string;

  /**
   * @generated from field: string marriage_date = 16;
   */
  marriageDate: string;

  /**
   * @generated from field: string has_contract = 17;
   */
  hasContract: string;

  /**
   * @generated from field: string contract_date = 18;
   */
  contractDate: string;

  /**
   * @generated from field: string contract_place = 19;
   */
  contractPlace: string;

  /**
   * @generated from field: string contract_type = 20;
   */
  contractType: string;

  /**
   * @generated from field: string id_file = 21;
   */
  idFile: string;

  /**
   * @generated from field: string non_financing_declaration_file = 22;
   */
  nonFinancingDeclarationFile: string;
};

/**
 * Describes the message leficaneur.form.v1.Person.
 * Use `create(PersonSchema)` to create a new message.
 */
export const PersonSchema: GenMessage<Person> = /*@__PURE__*/
  messageDesc(file_form_v1_form, 8);

/**
 * @generated from message leficaneur.form.v1.Corporation
 */
export type Corporation = Message<"leficaneur.form.v1.Corporation"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string capital = 3;
   */
  capital: string;

  /**
   * @generated from field: string address = 4;
   */
  address: string;

  /**
   * @generated from field: string siren = 5;
   */
  siren: string;

  /**
   * @generated from field: string registar = 6;
   */
  registar: string;

  /**
   * @generated from field: string delegate_gender = 7;
   */
  delegateGender: string;

  /**
   * @generated from field: string delegate_last_name = 8;
   */
  delegateLastName: string;

  /**
   * @generated from field: string delegate_first_name = 9;
   */
  delegateFirstName: string;

  /**
   * @generated from field: string delegate_phone = 10;
   */
  delegatePhone: string;

  /**
   * @generated from field: string delegate_email = 11;
   */
  delegateEmail: string;

  /**
   * @generated from field: string delegate_address = 12;
   */
  delegateAddress: string;

  /**
   * @generated from field: string kbis_file = 13;
   */
  kbisFile: string;

  /**
   * @generated from field: string statuts_file = 14;
   */
  statutsFile: string;

  /**
   * @generated from field: string delegate_id_file = 15;
   */
  delegateIdFile: string;

  /**
   * @generated from field: string non_financing_declaration_file = 16;
   */
  nonFinancingDeclarationFile: string;
};

/**
 * Describes the message leficaneur.form.v1.Corporation.
 * Use `create(CorporationSchema)` to create a new message.
 */
export const CorporationSchema: GenMessage<Corporation> = /*@__PURE__*/
  messageDesc(file_form_v1_form, 9);

/**
 * @generated from message leficaneur.form.v1.Funding
 */
export type Funding = Message<"leficaneur.form.v1.Funding"> & {
  /**
   * @generated from field: string contribution_amount = 1;
   */
  contributionAmount: string;

  /**
   * @generated from field: string loan_amount = 2;
   */
  loanAmount: string;

  /**
   * @generated from field: string loan_duration = 3;
   */
  loanDuration: string;

  /**
   * @generated from field: string interest_rate = 4;
   */
  interestRate: string;
};

/**
 * Describes the message leficaneur.form.v1.Funding.
 * Use `create(FundingSchema)` to create a new message.
 */
export const FundingSchema: GenMessage<Funding> = /*@__PURE__*/
  messageDesc(file_form_v1_form, 10);

/**
 * @generated from message leficaneur.form.v1.Notary
 */
export type Notary = Message<"leficaneur.form.v1.Notary"> & {
  /**
   * @generated from field: string has_notary = 1;
   */
  hasNotary: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string city = 3;
   */
  city: string;
};

/**
 * Describes the message leficaneur.form.v1.Notary.
 * Use `create(NotarySchema)` to create a new message.
 */
export const NotarySchema: GenMessage<Notary> = /*@__PURE__*/
  messageDesc(file_form_v1_form, 11);

/**
 * @generated from service leficaneur.form.v1.FormService
 */
export const FormService: GenService<{
  /**
   * @generated from rpc leficaneur.form.v1.FormService.Send
   */
  send: {
    methodKind: "unary";
    input: typeof SendRequestSchema;
    output: typeof SendResponseSchema;
  },
  /**
   * @generated from rpc leficaneur.form.v1.FormService.CreateForm
   */
  createForm: {
    methodKind: "unary";
    input: typeof CreateFormRequestSchema;
    output: typeof CreateFormResponseSchema;
  },
  /**
   * @generated from rpc leficaneur.form.v1.FormService.GetFormDefinition
   */
  getFormDefinition: {
    methodKind: "unary";
    input: typeof GetFormDefinitionRequestSchema;
    output: typeof GetFormDefinitionResponseSchema;
  },
  /**
   * @generated from rpc leficaneur.form.v1.FormService.UpdateSection1
   */
  updateSection1: {
    methodKind: "unary";
    input: typeof UpdateSection1RequestSchema;
    output: typeof UpdateSection1ResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_form_v1_form, 0);

